import React from "react";
import { Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { colors, fontFamily } from "./tokens";
import ProductPreview from "./ProductPreview";
import Reveal from "./Reveal";

const useStyles = makeStyles(theme => ({
  section: {
    padding: theme.spacing(20, 3, 10),
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(14, 2.5, 6)
    }
  },
  inner: {
    maxWidth: 1160,
    margin: "0 auto",
    textAlign: "center"
  },
  eyebrow: {
    display: "inline-flex",
    alignItems: "center",
    gap: 8,
    fontFamily,
    fontSize: 13,
    fontWeight: 500,
    color: colors.primaryDark,
    background: colors.primarySoft,
    borderRadius: 999,
    padding: "6px 14px",
    marginBottom: theme.spacing(3)
  },
  headline: {
    fontFamily,
    fontWeight: 700,
    letterSpacing: "-0.03em",
    lineHeight: 1.08,
    fontSize: "clamp(2.5rem, 5vw, 4.25rem)",
    color: colors.ink,
    margin: 0
  },
  sub: {
    fontFamily,
    fontWeight: 400,
    fontSize: "clamp(1.05rem, 1.6vw, 1.25rem)",
    lineHeight: 1.6,
    color: colors.inkMuted,
    maxWidth: 620,
    margin: theme.spacing(3, "auto", 5)
  },
  actions: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: theme.spacing(2),
    marginBottom: theme.spacing(9),
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
      alignItems: "stretch"
    }
  },
  primaryBtn: {
    fontFamily,
    textTransform: "none",
    fontWeight: 600,
    fontSize: 15,
    borderRadius: 8,
    padding: theme.spacing(1.4, 3.5),
    backgroundColor: colors.ink,
    color: "#fff",
    boxShadow: "none",
    "&:hover": {
      backgroundColor: "#000",
      boxShadow: "none"
    }
  },
  secondaryBtn: {
    fontFamily,
    textTransform: "none",
    fontWeight: 600,
    fontSize: 15,
    borderRadius: 8,
    padding: theme.spacing(1.4, 3.5),
    border: `1px solid ${colors.border}`,
    color: colors.ink,
    "&:hover": {
      background: colors.surfaceMuted
    }
  },
  previewWrap: {
    maxWidth: 980,
    margin: "0 auto"
  }
}));

export default function Hero() {
  const classes = useStyles();

  return (
    <section className={classes.section}>
      <div className={classes.inner}>
        <Reveal as="span" className={classes.eyebrow} style={{ display: "inline-flex" }}>
          Asset maintenance, unified
        </Reveal>

        <Reveal as="h1" className={classes.headline} delay={80}>
          Maintenance, managed
          <br />
          in one place.
        </Reveal>

        <Reveal as="p" className={classes.sub} delay={140}>
          One connected platform for asset owners, maintenance providers and
          technicians to manage assets, coordinate work, and stay ahead of
          problems - no spreadsheets, no disconnected tools.
        </Reveal>

        <Reveal as="div" className={classes.actions} delay={200}>
          <Button className={classes.primaryBtn} href="/auth/registration">
            Get Started
          </Button>
          <Button className={classes.secondaryBtn} href="#platform">
            Explore the Platform
          </Button>
        </Reveal>

        <Reveal as="div" className={classes.previewWrap} delay={260}>
          <ProductPreview />
        </Reveal>
      </div>
    </section>
  );
}
